import { apiFetch } from "./apiClient";

/** Ítem del catálogo de costos sugeridos (cuánto sale un trabajo/reparación). */
export interface CostoSugerido {
  id: number;
  nombre_trabajo: string;
  categoria?: string | null;
  precio?: number | null;
  descripcion?: string | null;
  /** Geografía estructurada (IDs + nombres resueltos por el backend). */
  region?: number | null;
  comuna?: number | null;
  sector?: number | null;
  regionNombre?: string | null;
  comunaNombre?: string | null;
  sectorNombre?: string | null;
  orden?: number;
  /** Fotos (metadatos). El detalle con URLs firmadas se trae por
   *  /costos-sugeridos/:id/archivos (lo maneja AttachmentsManager). */
  archivos?: unknown[];
  created_at?: string;
  updated_at?: string;
}

export type CostoSugeridoCreate = {
  nombre_trabajo: string;
  categoria?: string | null;
  precio?: number | null;
  descripcion?: string | null;
  region?: number | null;
  comuna?: number | null;
  sector?: number | null;
};

const BASE = "/costos-sugeridos";

export const costosSugeridosApi = {
  list: (): Promise<{ success: boolean; data: CostoSugerido[] } | null> =>
    apiFetch<{ success: boolean; data: CostoSugerido[] }>(BASE, {
      errorMsg: "Error al cargar los costos sugeridos",
    }),

  create: (
    body: CostoSugeridoCreate,
  ): Promise<{ success: boolean; data: CostoSugerido } | null> =>
    // Sin successMsg: la página muestra su propio toast accionable tras crear.
    apiFetch<{ success: boolean; data: CostoSugerido }>(BASE, {
      method: "POST",
      body: JSON.stringify(body),
      errorMsg: "Error al crear el costo",
    }),

  update: (
    id: number,
    body: Partial<CostoSugeridoCreate>,
  ): Promise<{ success: boolean; data: CostoSugerido } | null> =>
    apiFetch<{ success: boolean; data: CostoSugerido }>(`${BASE}/${id}`, {
      method: "PUT",
      body: JSON.stringify(body),
      successMsg: "Costo actualizado",
      errorMsg: "Error al actualizar el costo",
    }),

  remove: (id: number): Promise<{ success: boolean } | null> =>
    apiFetch<{ success: boolean }>(`${BASE}/${id}`, {
      method: "DELETE",
      successMsg: "Costo eliminado",
      errorMsg: "Error al eliminar el costo",
    }),

  reorder: (ids: number[]): Promise<{ success: boolean } | null> =>
    apiFetch<{ success: boolean }>(`${BASE}/reorder`, {
      method: "PUT",
      body: JSON.stringify({ ids }),
      errorMsg: "Error al reordenar",
    }),
};
